import { useTheme } from 'styled-components/macro'
import { colors } from 'theme/colors'

type SVGProps = React.SVGProps<SVGSVGElement> & { fill?: string }

const useEmptyStateIconColors = () => {
  const theme = useTheme()
  const primary = theme.darkMode ? colors.gray150 : colors.gray600
  const secondary = theme.darkMode ? colors.gray600 : colors.gray300
  return { primary, secondary }
}

export const EmptyActivityIcon = (props: SVGProps) => {
  const { primary, secondary } = useEmptyStateIconColors()
  return (
    <svg {...props} width="96" height="66" viewBox="0 0 96 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="89.2"
        y="8.3"
        width="30.4"
        height="82.4"
        rx="5.2"
        transform="rotate(90 89.2 8.3)"
        stroke={secondary}
        strokeWidth="2.4"
      />
      <line x1="17.7" y1="19.3" x2="23.3" y2="19.3" stroke={secondary} strokeWidth="2.4" strokeLinecap="round" />
      <line x1="17.7" y1="24.3" x2="23.3" y2="24.3" stroke={secondary} strokeWidth="2.4" strokeLinecap="round" />
      <line x1="28.7" y1="19.3" x2="78.3" y2="19.3" stroke={secondary} strokeWidth="2.4" strokeLinecap="round" />
      <line x1="28.7" y1="24.3" x2="78.3" y2="24.3" stroke={secondary} strokeWidth="2.4" strokeLinecap="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 56.5C29.6274 56.5 35 51.1274 35 44.5C35 37.8726 29.6274 32.5 23 32.5C16.3726 32.5 11 37.8726 11 44.5C11 51.1274 16.3726 56.5 23 56.5ZM27.5 44.5L23 40L18.5 44.5L23 49L27.5 44.5Z"
        fill={primary}
      />
    </svg>
  )
}

export const EmptyTokensIcon = (props: SVGProps) => {
  const { primary, secondary } = useEmptyStateIconColors()
  return (
    <svg {...props} width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_963_209164)">
        <rect
          x="35.5728"
          y="23.4258"
          width="8.46281"
          height="36.0727"
          rx="2.32727"
          transform="rotate(90 35.5728 23.4258)"
          fill={secondary}
        />
        <rect
          x="35.5728"
          y="11.9629"
          width="8.46281"
          height="36.0727"
          rx="2.32727"
          transform="rotate(90 35.5728 11.9629)"
          fill={secondary}
        />
        <rect
          x="40.2271"
          y="0.5"
          width="8.46281"
          height="36.0727"
          rx="2.32727"
          transform="rotate(90 40.2271 0.5)"
          fill={secondary}
        />
        <rect
          x="39.0635"
          y="34.8887"
          width="8.46281"
          height="36.0727"
          rx="2.32727"
          transform="rotate(90 39.0635 34.8887)"
          fill={secondary}
        />
        <rect
          x="35.5728"
          y="46.3511"
          width="8.46281"
          height="36.0727"
          rx="2.32727"
          transform="rotate(90 35.5728 46.3511)"
          fill={secondary}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M49.4092 65.5C58.2457 65.5 65.4092 58.3366 65.4092 49.5C65.4092 40.6634 58.2457 33.5 49.4092 33.5C40.5726 33.5 33.4092 40.6634 33.4092 49.5C33.4092 58.3366 40.5726 65.5 49.4092 65.5ZM55.4092 49.5L49.4092 43.5L43.4092 49.5L49.4092 55.5L55.4092 49.5Z"
          fill={primary}
        />
      </g>
      <defs>
        <clipPath id="clip0_963_209164">
          <rect width="66" height="65" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
